__turbopack_context__.v({
  "btnBuilder": "WebsiteBuilderSection-module__daGsJW__btnBuilder",
  "builder": "WebsiteBuilderSection-module__daGsJW__builder",
  "checkIcon": "WebsiteBuilderSection-module__daGsJW__checkIcon",
  "content": "WebsiteBuilderSection-module__daGsJW__content",
  "description": "WebsiteBuilderSection-module__daGsJW__description",
  "listGrid": "WebsiteBuilderSection-module__daGsJW__listGrid",
  "listItem": "WebsiteBuilderSection-module__daGsJW__listItem",
  "mockupImage": "WebsiteBuilderSection-module__daGsJW__mockupImage",
  "tag": "WebsiteBuilderSection-module__daGsJW__tag",
  "title": "WebsiteBuilderSection-module__daGsJW__title",
  "visual": "WebsiteBuilderSection-module__daGsJW__visual",
  "wrapper": "WebsiteBuilderSection-module__daGsJW__wrapper",
});
